import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Your existing imports
import Layout from "./layout/Layout";
import "./App.css";
import Homepage from "./pages/homepage/Homepage";
import Expertise from "./pages/expertise/Expertise";
import LetsTalk from "./pages/lets_talk/LetsTalk";
import AdminLayout from "./layout/AdminLayout";
import Admin_Letstalk from "./admin_pages/lets_talk/Admin_Letstalk";
import Letstalk_View from "./admin_pages/letstalkview/Letstalk_View";
import JoinOurTeam from "./pages/joinourteam/JoinOurTeam";
import JoinOurTeam_View from "./pages/joinouteam_view/JoinOurTeam_View";
import Apply_Join_Our_Team from "./pages/apply_join_our_team/Apply_Join_Our_Team";
import AdminLogin from "./admin_pages/login/AdminLogin ";
import Admin_Join_Our_Team from "./admin_pages/joinourteam/Admin_Join_Our_Team";
import Job_View from "./admin_pages/job_view/Job_View";
import Job_Create from "./admin_pages/job_create/Job_Create";
import Candidates_List from "./admin_pages/candidates/Candidates_List";
import Candidates_View from "./admin_pages/candidates_view/Candidates_View";
import ProtectedRoute from "./protectedroute/ProtectedRoute";
import CreateBlog from "./admin_pages/createblog/CreateBlog";
import Blog_list from "./pages/blog_list/Blog_list";
import BlogView from "./pages/blogview/BlogView";
import Blog from "./admin_pages/blog/Blog";
import AdminBlogView from "./admin_pages/blogview/AdminBlogView";
import Gallery from "./pages/gallery/Gallery";

// 🔹 Loader imports
import { LoaderProvider, useLoader } from "./contexts/LoaderContext";
import { setLoaderFunctions } from "./axios/index";
import Loader from "./components/loader/Loader";
import TechStack from "./pages/techstack/TechStack";
import Products from "./pages/products/Products";
import NotFound from "./layout/NotFound";
import PrivacyPolicy from "./pages/privacypolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/termsandconditions/TermsAndConditions";
import ScrollToTop from "./components/scrolltop/ScrollToTop";
import ArtificialIntelligence from "./pages/artificalintellegence/ArtificialIntelligence";
import Services from "./pages/services/Services";
import CloudTechnologies from "./pages/cloudpage/CloudTechnologies";
import ERPSolutions from "./pages/erpsolutions/ERPSolutions";
import CaseStudyOne from "./controller/casestudies/CaseStudyOne";
import CaseStudyTwo from "./controller/casestudies/CaseStudyTwo";
import CaseStudyList from "./pages/casestudylist/CaseStudyList";
import OverlayCard from "./components/OverlayCard/OverlayCard";
import ErpDemoPage from "./pages/videodata/VideoData";

// 🔹 Component to hook loader into your app
const AppContent = () => {
  const { loading, setLoading } = useLoader();

  useEffect(() => {
    setLoaderFunctions(
      () => setLoading(true),
      () => setLoading(false),
    );
  }, [setLoading]);

  return (
    <>
      {loading && <Loader />}
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <div>
                <Homepage />
              </div>
            }
          />
          <Route element={<Layout />}>
            {/* <Route path="/expertise" element={<Expertise />} /> */}
            <Route path="/lets-talk" element={<LetsTalk />} />
            <Route path="/join-our-team" element={<JoinOurTeam />} />
            <Route
              path="/artificial-intelligence"
              element={<ArtificialIntelligence />}
            />
            <Route
              path="/join-our-team-view/:jobIdParam"
              element={<JoinOurTeam_View />}
            />
            <Route
              path="/:jobIdParam/apply"
              element={<Apply_Join_Our_Team />}
            />
            <Route path="/Blog" element={<Blog_list />} />
            <Route path="/blog/:id/:slug" element={<BlogView />} />

            {/* <Route path="/who-we-are" element={<Gallery />} /> */}
            {/* <Route path="/TechStack" element={<TechStack />} /> */}
            <Route path="/Products" element={<Products />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsAndConditions />} />
            <Route
              path="/cloud-managed-services"
              element={<CloudTechnologies />}
            />
            <Route path="erp-managed-services" element={<ERPSolutions />} />
            <Route
              path="/insights/erp-product-videos-tour"
              element={<ErpDemoPage />}
            />
            <Route
              path="/case-studies/intelligent-fleet-automation-revenue-growth"
              element={<CaseStudyOne />}
            />
            <Route
              path="/case-studies/agritech-saas-leadership-transition-stability"
              element={<CaseStudyTwo />}
            />
            <Route path="/success-stories" element={<CaseStudyList />} />
            <Route path="/OverlayCard" element={<OverlayCard />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/AdminLogin" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/admin/lets-talk" element={<Admin_Letstalk />} />
            <Route path="/admin/lets-talk/view" element={<Letstalk_View />} />
            <Route
              path="/admin/join-our-team"
              element={<Admin_Join_Our_Team />}
            />
            <Route path="/admin/job-create" element={<Job_Create />} />
            <Route path="/admin/job-view" element={<Job_View />} />
            <Route
              path="/admin/candidates-list"
              element={<Candidates_List />}
            />
            <Route
              path="/admin/candidates-view"
              element={<Candidates_View />}
            />
            <Route path="/admin/create-blog" element={<CreateBlog />} />
            <Route path="/admin/Blog" element={<Blog />} />
            <Route path="/admin/Blog-View/:id" element={<AdminBlogView />} />
          </Route>
          {/* Old HTML redirects */}
          <Route
            path="/team.html"
            element={<Navigate to="/join-our-team" replace />}
          />
          <Route
            path="/aiml.html"
            element={<Navigate to="/artificial-intelligence" replace />}
          />
          <Route
            path="/devops.html"
            element={<Navigate to="/cloud-managed-services" replace />}
          />
          <Route
            path="/bigdata.html"
            element={<Navigate to="/Services" replace />}
          />
          <Route
            path="/talenthunt.html"
            element={<Navigate to="/join-our-team" replace />}
          />
          <Route
            path="/cloudsolutions.html"
            element={<Navigate to="/cloud-managed-services" replace />}
          />
          <Route
            path="/contact.html"
            element={<Navigate to="/lets-talk" replace />}
          />
          <Route
            path="/digital.html"
            element={<Navigate to="/Services" replace />}
          />
          <Route
            path="/products.html"
            element={<Navigate to="/Products" replace />}
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
};

// 🔹 Final export wrapped in LoaderProvider
const App = () => {
  return (
    <LoaderProvider>
      <AppContent />
    </LoaderProvider>
  );
};

export default App;
